import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-cy": "preloader",
    class: "asPreloader",
    style: _normalizeStyle(_ctx.style)
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", null, null, -1),
    _createElementVNode("span", null, null, -1),
    _createElementVNode("span", null, null, -1)
  ]))], 4))
}